import { NetworkEnums } from '../../../../shared/GameEnums.ts';
import { ClientShuffleQueueController } from '../shuffle/ClientShuffleQueueController.ts';
const ShuffleState = NetworkEnums.ShuffleState;
export class SocketShuffleListen {
    constructor(socketController){
        this.shuffleStateHandlers = new Map();
        socketController.setStateHandler(NetworkEnums.State.ShuffleStateUpdate, (data)=>{
            var _this_shuffleStateHandlers_get;
            (_this_shuffleStateHandlers_get = this.shuffleStateHandlers.get(data.type)) === null || _this_shuffleStateHandlers_get === void 0 ? void 0 : _this_shuffleStateHandlers_get(data.payload);
        });
        this.shuffleStateHandlers.set(ShuffleState.ShuffleQueueData, (queueData)=>{
            ClientShuffleQueueController.updateQueueData(queueData);
        });
        this.shuffleStateHandlers.set(ShuffleState.ShufflePlayerData, (playerData)=>{
            ClientShuffleQueueController.updatePlayerData(playerData);
        });
    }
}
